module.exports = __webpack_public_path__ + "img/greenCopy.44f1adb4.svg";